<template>
    <b-row>
        <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <div class="filter-wrapper">
                <b-input-group prepend>
                    <b-form-input
                        placeholder="Search"
                        v-model="keyword"
                        @input="setParam">
                    </b-form-input>
                    <b-dropdown text="Advanced" variant="primary" slot="append">
                        <b-dropdown-item
                            v-for="(option, index) in advance_search_options"
                            :key="'advance_option_' + index"
                            @click="selectAdvanceOption(index)">
                            {{ option }}
                            <i class="ml-1" v-if="selected_advance_option === index">
                                <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                            </i>
                        </b-dropdown-item>
                    </b-dropdown>
                </b-input-group>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "InventoryPageToolbar",
    data() {
        return {
            category: {
                selected: "all",
                options: [],
                initial_category: {
                    value: "all",
                    text: "All Categories"
                }
            },
            advance_search_options: [],
            selected_advance_option: "all",
            keyword: ""
        };
    },
    created: function() {
        this.getCategories();
        this.getAdvanceSearch();
    },
    computed: {
        ...mapState("estoreInventories", ["categories", "advance_search"]),
        ...mapState("estoreLocations", ["branchInfo", "param"])
    },
    methods: {
        showModal: function(type) {
            this.$store.commit("estoreInventories/setModal", {
                type: type,
                status: true
            });
            this.$store.commit("estoreInventories/errors", null);
        },

        getCategories: async function() {
            this.category.options = [];
            await this.$store
                .dispatch("estoreInventories/getCategories")
                .then(() => {
                    this.category.options.push(this.category.initial_category);

                    this.categories.map(category => {
                        this.category.options.push({ value: category.id, text: category.name });
                    });
                });
        },

        getAdvanceSearch: async function() {
            await this.$store
                .dispatch("estoreInventories/getAdvanceSearch")
                .then(() => {
                    this.advance_search_options = this.advance_search;
                });
        },

        selectAdvanceOption: function(value) {
            this.selected_advance_option = value;
        },

        setParam: function() {
            let param = {
                branchUuid: this.branchInfo.uuid,
                page: this.param.page,
                payload: {
                    filters: {
                        paired_key: this.category.selected,
                        keyword: this.keyword,
                        column: this.selected_advance_option
                    }
                }
            };
            this.$store.commit("estoreLocations/setParam", param);
        }
    }
};
</script>
